import { render, staticRenderFns } from "./doc_flow.vue?vue&type=template&id=c36e1a8c&scoped=true"
import script from "./doc_flow.vue?vue&type=script&lang=js"
export * from "./doc_flow.vue?vue&type=script&lang=js"
import style0 from "./doc_flow.vue?vue&type=style&index=0&id=c36e1a8c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36e1a8c",
  null
  
)

export default component.exports